module.exports = __webpack_public_path__ + "48cdcd7e93bb6c6e04a439a6ad343507.png";